var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 52 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.075 1.3a16.28 16.28 0 0 0-14.2 1.7A2.08 2.08 0 0 1 24.6 3 16.23 16.23 0 0 0 11.55.975 15.2 15.2 0 0 0 .25 15.7C0 33 17.9 42.45 23.825 45.15a5 5 0 0 0 3.85.125C33.575 43 50.875 34.8 51.2 15.5A15.325 15.325 0 0 0 41.075 1.3",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.075 1.3a16.27 16.27 0 0 0-14.2 1.7A2.08 2.08 0 0 1 24.6 3 16.23 16.23 0 0 0 11.55.975 15.2 15.2 0 0 0 .25 15.7a24.5 24.5 0 0 0 .475 5h50c.319-1.715.478-3.455.475-5.2A15.325 15.325 0 0 0 41.075 1.3"
  })));
};
export default SvgHeart;